import { define } from 'wicked-elements'
import SnapSlider from '@tannerhodges/snap-slider'

define('[data-component="inline-slideshow"]', {
  init() {
    this.id = this.element.id
    this.$slider = this.element.querySelector('[data-slider]')
    this.$nav = this.element.querySelector('[data-slider-nav]')
    this.$caption = this.element.querySelector('figcaption')

    this.slider = new SnapSlider(this.$slider, {
      nav: '[data-slider-nav]',
      prev: '[data-prev]',
      next: '[data-next]',
      loop: true,
      on: {
        change: () => {
          const $current = this.slider.slides[this.slider.current - 1]
          this.$caption.innerHTML = $current.getAttribute('data-caption') || '&nbsp;'
        }
      }
    })

    this.goToNext = this.goToNext.bind(this)
  },
  connected () {
    this.$slider.addEventListener('click', this.goToNext)
  },
  disconnected () {
    this.$slider.removeEventListener('click', this.goToNext)
  },
  goToNext () {
    this.slider.goto('next', { immediate: true })
  }
})